import { render, staticRenderFns } from "./DeptRoleInfo.vue?vue&type=template&id=9d055384&scoped=true"
import script from "./DeptRoleInfo.vue?vue&type=script&lang=js"
export * from "./DeptRoleInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d055384",
  null
  
)

export default component.exports